import { Pipe, PipeTransform } from '@angular/core';
import { isValidUrl } from '../text-utils';

@Pipe({
    name: 'reportUrl',
    standalone: false
})
export class ReportUrlPipe implements PipeTransform {
  transform(value: string | null | undefined): string | null | undefined {
    if (value === undefined || value === null || value === '')
      return value;

    if (isValidUrl(value)) {
      return value;
    }

    const urlStartTag = '[url]';
    const urlEndTag = '[\\url]';

    const startIndex = value.indexOf(urlStartTag);
    const endIndex = value.indexOf(urlEndTag);

    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
      return value.substring(startIndex + urlStartTag.length, endIndex);
    } else {
      return value;
    }
  }
}
